import { render, staticRenderFns } from "./ProtocolControlReport.vue?vue&type=template&id=2d082512&scoped=true"
import script from "./ProtocolControlReport.vue?vue&type=script&lang=js"
export * from "./ProtocolControlReport.vue?vue&type=script&lang=js"
import style0 from "./ProtocolControlReport.vue?vue&type=style&index=0&id=2d082512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d082512",
  null
  
)

export default component.exports